import React, { FC } from 'react'
import { CheckWithElement } from 'Pages/landings/newLandings/common/components'
import manageAccountWebp from './manageAccount.webp'
import manageAccountJpg from './manageAccount.jpg'
import { ListWithImg, Title, Text } from './styled'

export const ManageAccountComponent: FC = () => (
	<ListWithImg imgWebp={manageAccountWebp} imgJpg={manageAccountJpg} isReverse>
		<Title>Управляйте в личном кабинете</Title>
		<CheckWithElement
			text={() => <Text>Отслеживайте динамику продаж и размер комиссии онлайн</Text>}
		/>
		<CheckWithElement
			text={() => <Text>Подключайте новые торговые точки и заказывайте оборудование</Text>}
		/>
		<CheckWithElement
			text={() => <Text>Работайте с возвратами: оформляйте заявки на отмену транзакций</Text>}
		/>
		<CheckWithElement
			text={() => <Text>Анализируйте продажи: по торговым точкам или терминалам</Text>}
		/>
	</ListWithImg>
)
